import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
const ApplicationActionBar = (props) => {
    const { items, nodeRef, className = '' } = props, remainingProps = __rest(props, ["items", "nodeRef", "className"]);
    return (_jsx("ul", Object.assign({}, remainingProps, { className: `ApplicationActionBar nav navbar-nav navbar-right ${className}`, ref: nodeRef }, { children: items === null || items === void 0 ? void 0 : items.map((item, index) => {
            return (_jsx("li", Object.assign({ role: 'presentation', className: 'navigationItem' }, { children: item }), index));
        }) })));
};
export default ApplicationActionBar;
